import { render, staticRenderFns } from "./gacha.vue?vue&type=template&id=1b7e5de6&scoped=true&"
import script from "./gacha.vue?vue&type=script&lang=js&"
export * from "./gacha.vue?vue&type=script&lang=js&"
import style0 from "./gacha.vue?vue&type=style&index=0&id=1b7e5de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7e5de6",
  null
  
)

export default component.exports